import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import FocusLockUI from './Lock';
import FocusTrap from './Trap';

var FocusLockCombination = function FocusLockCombination(props) {
  return React.createElement(FocusLockUI, _extends({
    sideCar: FocusTrap
  }, props));
};

var _ref = FocusLockUI.propTypes || {},
    sideCar = _ref.sideCar,
    propTypes = _objectWithoutPropertiesLoose(_ref, ["sideCar"]);

FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
export default FocusLockCombination;